import { Box } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * POM-6087 — an unverified claim on an inventory row: stock that left the shelf which
 * inventory never received.
 *
 * Shared by the two dashboard tables rather than defined in each, so the two views cannot drift
 * apart on how the same number reads. Shown as the positive magnitude the API returns, in the
 * warning colour: the column heading already says it is a deficit, and a minus sign on top of
 * that read as negative stock.
 *
 * Renders nothing at zero. A 0 beside every drug reads as a measurement that was taken, rather
 * than as "there is nothing here to chase".
 */
const UnverifiedCell = ({ value }) =>
  value > 0 ? (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Box component='span' sx={{ fontWeight: 700, fontSize: '0.8rem', color: 'warning.dark' }}>
        {value}
      </Box>
    </Box>
  ) : null;

UnverifiedCell.propTypes = { value: PropTypes.number };

UnverifiedCell.defaultProps = { value: 0 };

export default UnverifiedCell;
